import React from "react";
import {
  Stepper,
  Step,
  StepLabel,
  useTheme,
  useMediaQuery,
} from "@mui/material";

export default function CustomStepper({ steps, activeStep }) {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm")); // 👈 true on xs/sm screens
  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel={isSmall} // 👈 makes steps spread evenly
      sx={{
        "& .MuiStepIcon-root": {
          fontSize: "2rem", // Increase the size of step icons
        },
        height: isSmall ? 110 : 35,
        // "& .MuiStepLabel-label": {
        //   whiteSpace: "normal", // 👈 allow text to wrap
        //   fontSize: "0.875rem", // 👈 smaller font
        //   textAlign: "center",
        // },
        width: "100%",
        overflowX: "auto", // 👈 allow horizontal scroll if needed
      }}
    >
      {steps.map((label, index) => (
        <Step key={label}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}
